/* eslint-disable */
import { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  getFund,
  getPart,
} from "../../utils/store/actions/funds.actions";
import {
  Button,
  Card,
  CardContent,
} from "@material-ui/core";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { show } from "redux-modal";
import Loading from "../../components/Share/Loading";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ModalManageDocument from "../../components/Modal/Modal.ManageDocument";
import { getPartEnvelopes } from "../../utils/store/actions/document.actions";


const styles = (theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.paper,
      maxHeight: 400,
      overflow: "auto",
      margin: 10,
    },
    card: {
      borderRadius: "12px",
      margin: "1%",
    },
    listItem: {
      border: "1px solid #EAEDF7",
      borderRadius: "12px",
      marginBottom: "10px",
      boxShadow: "0px 2px 4px rgba(28, 41, 90, 0.0367952)",
      "&:hover": {
        cursor: "pointer",
        background: "#F5F6FF",
      },
    },
  });

class PartDocuments extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      documents: undefined,
    };
  }

  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);
  partId = this.urlParams.get("partId");
  fundPersonId = this.urlParams.get("id");

  render() {
    const { classes, t } = this.props;
    return (
      <>
        <div style={{ margin: "1%", fontWeight: "bolder" }}>
                {t("DOCUMENTS")}
              </div>
        {!this.props.Documents.partDocuments && (
          <Card className={classes.card}>
            <CardContent
              className={classes.colorCards}
              style={{
                display: "flex",
                justifyContent: "center",
                padding: 0,
              }}
            >
              <Button
                style={{
                  textTransform: "none",
                  border: "1px solid #ae0064",
                  color: "#ae0064",
                  borderRadius: "12px",
                  margin: "1%",
                  minWidth: "250px",
                }}
              >
                <Loading />
              </Button>
            </CardContent>
          </Card>
        )} {this.props.Documents.partDocuments &&
                this.props.Documents.partDocuments?.length !== 0 &&
                this.props.Documents.partDocuments?.some(
                  (doc: any) => doc.isDeleted === false
                ) ? (
                <Card className={classes.card}>
                  <CardContent
                    className={classes.colorCards}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: 0,
                    }}
                  >
                    <Button
                      style={{
                        textTransform: "none",
                        border: "1px solid #ae0064",
                        color: "#ae0064",
                        borderRadius: "12px",
                        margin: "1%",
                        minWidth: "250px",
                      }}
                      onClick={(e: any) =>
                        this.props.show("manage_document_part", {
                          name: "manage_document_part",
                          history,
                          actionDone: "DIRECTORY_PART",
                          parentDirectoryId: this.fundPersonId,
                        })
                      }
                    >
                      {t("MANAGE_DIRECTORIES")}
                    </Button>
                  </CardContent>
                </Card>
              ) : (
                (this.props.Documents.partDocuments?.length === 0) && (
                  <Card className={classes.card}>
                    <CardContent
                      className={classes.colorCards}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: 0,
                      }}
                    >
                      <Button
                        style={{
                          textTransform: "none",
                          border: "1px solid #ae0064",
                          color: "#ae0064",
                          borderRadius: "12px",
                          margin: "1%",
                          minWidth: "250px",
                        }}
                        onClick={(e: any) =>
                          this.props.show("add_doc_directory", {
                            name: "add_doc_directory",
                            history,
                            actionDone: "DIRECTORY_PART",
                            parentDirectoryId: this.fundPersonId,
                          })
                        }
                      >
                        <AddCircleOutlineIcon
                          style={{
                            color: "#ae0064",
                            marginRight: "20px",
                          }}
                        />
                        {t("ADD_DOCUMENT_OR_FOLDER")}
                      </Button>
                    </CardContent>
                  </Card>
                )
        )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getPart,
  show,
  getFund,
  getPartEnvelopes,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(PartDocuments)));
